import { h } from 'preact'
import { useEffect, useRef, useState } from 'preact/hooks'
import * as styles from "./ParallaxImage.module.css";

const gateUrl = new URL("../../assets/images/gate.png", import.meta.url).href;

interface ParallaxImageProps {
    speed?: number // how strong the parallax movement is
    direction?: 'up' | 'down' // parallax scroll direction
}

const ParallaxImage = ({ speed = 0.2, direction = 'down' }: ParallaxImageProps) => {
    const ref = useRef<HTMLImageElement>(null)
    const [isMobile, setIsMobile] = useState(false)

    // check mobile on mount + resize
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768)
        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    useEffect(() => {
        const factor = direction === 'down' ? -1 : 1
        let ticking = false

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    if (ref.current) {
                        const offsetY = window.scrollY * speed * factor
                        if (isMobile) {
                            // mobile: centered
                            ref.current.style.transform = `translate(-50%, -50%) translateY(${offsetY}px)`
                        } else {
                            // desktop: fixed to right, vertically centered
                            ref.current.style.transform = `translateY(-50%) translateY(${offsetY}px)`
                        }
                    }
                    ticking = false
                })
                ticking = true
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [speed, direction, isMobile])

    return (
        <img
            ref={ref}
            src={gateUrl}
            alt="Parallax Background"
            className={styles.img}
            style={{
                position: 'fixed',
                top: '50%',
                width: isMobile ? '80%' : '500px',
                pointerEvents: 'none',
                willChange: 'transform',
                zIndex: 0,
                ...(isMobile ? { left: '50%' } : { right: 0 }),
                transform: isMobile
                    ? 'translate(-50%, -50%)'
                    : 'translateY(-50%)', // initial before scroll
            }}
        />
    )
}

export default ParallaxImage
